import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connectorTypesService } from '../services/connectorTypesService';
import './ConnectorTypes.css';

const ConnectorTypes = () => {
  const [connectorTypes, setConnectorTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadConnectorTypes();
  }, []);

  const loadConnectorTypes = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await connectorTypesService.list();
      setConnectorTypes(response.connectorTypes || []);
    } catch (err) {
      console.error('Error loading connector types:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Are you sure you want to delete connector type "${name}"?`)) {
      return;
    }

    try {
      await connectorTypesService.delete(id);
      await loadConnectorTypes();
    } catch (err) {
      console.error('Error deleting connector type:', err);
      alert(`Failed to delete connector type: ${err.message}`);
    }
  };

  const filteredConnectorTypes = connectorTypes.filter(ct =>
    ct.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="connector-types-page">
        <div className="page-header">
          <h1>Connector Types</h1>
        </div>
        <div className="loading">Loading connector types...</div>
      </div>
    );
  }

  return (
    <div className="connector-types-page">
      <div className="page-header">
        <h1>Connector Types</h1>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/admin/connector-types/create')}
        >
          Create Connector Type
        </button>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search connector types..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <button
          className="btn btn-secondary"
          onClick={loadConnectorTypes}
        >
          Refresh
        </button>
      </div>

      <div className="connector-types-list">
        <table className="connector-types-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Created</th>
              <th>Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredConnectorTypes.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">
                  {searchTerm ? 'No connector types found matching your search' : 'No connector types found'}
                </td>
              </tr>
            ) : (
              filteredConnectorTypes.map(ct => (
                <tr key={ct.id}>
                  <td>{ct.id}</td>
                  <td>{ct.name}</td>
                  <td>{new Date(ct.insertdate).toLocaleString()}</td>
                  <td>{new Date(ct.updatedate).toLocaleString()}</td>
                  <td className="actions">
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={() => navigate(`/admin/connector-types/${ct.id}`)}
                    >
                      View
                    </button>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => navigate(`/admin/connector-types/${ct.id}/edit`)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-info"
                      onClick={() => navigate(`/admin/connector-types/${ct.id}/settings`)}
                    >
                      Settings
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(ct.id, ct.name)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="connector-types-summary">
        Total: {filteredConnectorTypes.length} connector type{filteredConnectorTypes.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
};

export default ConnectorTypes;
